import { Banner } from 'components/Banner/Banner'
import { Typography, TYPOGRAPHY_WEIGHT } from 'components/Typography'

export const ContractItemsTemplatePopover = () => {
  return (
    <div className="column gap-12 contract-items-table__template-upload-popover">
      <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.BOLD}>
        How to upload an item list
      </Typography.Headline6>
      <div className="column gap-8">
        <Typography.Body1>1. Download template.</Typography.Body1>
        <Typography.Body1>
          2. Populate the template with the price details.
        </Typography.Body1>
        <Banner.Warning text="Note that mandatory columns are marked with an asterisk. If required, you have the ability to add extra columns starting from cell M2 of the template." />
        <Typography.Body1>
          3. Upload populated template to the system.
        </Typography.Body1>
      </div>
    </div>
  )
}
